



















































































import FlightSegment from "@/store/entities/flight/flightSegment";
import { Component, Vue } from "vue-property-decorator";
import AddFlightSegment from "./modals/addFlightSegment.vue";

@Component({
  components: { AddFlightSegment },
})
export default class FlightSegments extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  flightSegments: FlightSegment[] = [];

  created() {
    this.getFlightSegments();
    (this.headers = [
      { text: "ID", value: "id" },
      { text: "İsim", value: "name" },
      { text: "İşlemler", value: "transactions" },
    ]),
      (this.mockData = [
        {
          id: "A",
          name: "Y",
        },
      ]);

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Tanımlamalar", disabled: true },
      { text: "Uçak Bölümleri", disabled: true },
    ];
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getFlightSegments() {
    await this.$store.dispatch({
      type: "flightSegment/getFlightSegments",
    });

    this.flightSegments = this.$store.state.flightSegment.list;
  }

  editFlightSegment(item) {
    this.$store.state.flightSegment.editFlightSegment = item;
    this.isOpenModal = true;
  }

  openModal() {
    this.$store.state.flightSegment.editFlightSegment = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getFlightSegments();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
